/**
 * ログユーティリティ
 * 開発環境でのみログを出力する
 */

const isDev = import.meta.env.DEV;

/**
 * 開発環境でのみログを出力
 * @param {...any} args - ログに出力する引数
 */
export function devLog(...args) {
  if (isDev) {
    console.log(...args);
  }
}

/**
 * 開発環境でのみエラーログを出力
 * @param {...any} args - ログに出力する引数
 */
export function devError(...args) {
  if (isDev) {
    console.error(...args);
  }
}

/**
 * 開発環境でのみ警告ログを出力
 * @param {...any} args - ログに出力する引数
 */
export function devWarn(...args) {
  if (isDev) {
    console.warn(...args);
  }
}

